import React, { CSSProperties } from 'react'

import clsx from 'clsx'

export const TooltipPosition = {
  TOP: 'top',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  LEFT: 'left'
} as const

export type TooltipPosition = (typeof TooltipPosition)[keyof typeof TooltipPosition]

interface Props {
  text: string
  position: TooltipPosition
  style?: CSSProperties
}

export const toolTipPositionClass = (position: TooltipPosition) => {
  switch (position) {
    case TooltipPosition.TOP:
      return (
        '-translate-x-1/2 -translate-y-full after:-bottom-2 after:left-1/2 after:-ml-1 ' +
        'after:border-t-8 after:border-r-4 after:border-l-4 after:border-x-transparent after:border-b-transparent after:border-t-surface'
      )
    case TooltipPosition.BOTTOM:
      return (
        '-translate-x-1/2 after:-top-2 after:left-1/2 after:-ml-1 ' +
        'after:border-b-8 after:border-r-4 after:border-l-4 after:border-x-transparent after:border-t-transparent after:border-b-surface'
      )
    case TooltipPosition.RIGHT:
      return (
        '-translate-y-1/2 after:top-1/2 after:-left-2 after:-mt-1 ' +
        'after:border-t-4 after:border-b-4 after:border-r-8 after:border-y-transparent after:border-l-transparent after:border-r-surface'
      )
    case TooltipPosition.LEFT:
      return (
        '-translate-x-full -translate-y-1/2 after:top-1/2 after:-right-2 after:-mt-1 ' +
        'after:border-t-4 after:border-b-4 after:border-l-8 after:border-y-transparent after:border-r-transparent after:border-l-surface'
      )
  }
  return ''
}

const ToolTip = React.memo(({ text, position, style = {} }: Props) => {
  const className = toolTipPositionClass(position)

  return (
    <span
      className={clsx(
        'z-modal bg-surface shadow-300 fixed rounded-lg break-all transition after:absolute after:border-solid after:content-[""]',
        className
      )}
      style={{ ...style }}
    >
      <span className='text-size-13 text-primary relative inline-block w-auto max-w-60 px-4 py-2 font-normal break-all whitespace-normal'>
        {text}
      </span>
    </span>
  )
})

export default ToolTip
